import React, { useState , useEffect} from 'react'; 
import { Link } from 'react-router-dom';
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
const Testimonials = () => {

  const [selectedTestimonial, setSelectedTestimonial] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      const filterData = messages.filter((item) => item.category === "Principal") 
      setData(filterData);
    };
    fetchData();
  }, []);

  const testimonials = [
    {
      name: data[0]?.name || ' name',
      designation: data[0]?.designation || '',
      message: 'Principal’s Message',
      testimonial: data[0]?.message || '',
      image: data[0]?.attachments ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0].attachments}` : 'https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/default.png',
      link: '/PrincipalMessage'
    },
  
    // Add more testimonials as needed
  ];

    const handleTestimonialClick = (index) => {
        setSelectedTestimonial(selectedTestimonial === index ? 0 : index);
    };

    return (
        <div className="message-container"> 
        <div className="messageimg"> 
  
            {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial">
                    <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        onClick={() => handleTestimonialClick(index)}
                        className={selectedTestimonial === index ? 'active' : ''}
                    />
                </div>
            ))}
            <div className="messageboximg">
                           <p>{testimonials[selectedTestimonial].name} <span>{testimonials[selectedTestimonial].designation}</span> </p>
                           <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/message-gif.gif" className="img-fluid qut-gif"/> </LazyLoad>
                        </div>
        </div>
             <div className="messagebox">
             <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/quote.png" className="img-fluid msg-gif"/> </LazyLoad>
                 <div className={`${selectedTestimonial !== 0 ? 'slide-in' : 'slide-out'}`}>
                {selectedTestimonial !== null && (
                    <div>
                       <div className="messagedesc">
                          <p><div dangerouslySetInnerHTML={{ __html: testimonials[selectedTestimonial].testimonial }} /> </p>
                       
                       </div>
                        
                        <div className="mainbtn"><Link to={testimonials[selectedTestimonial].link}> 
                        
                        <button className='button'><Link to="/PrincipalMessage">Read More <i class="bi bi-arrow-right"></i></Link></button>
                        </Link></div>
                    </div>
                )}
            </div>
            </div> 
            
        </div>
    );
};

export default Testimonials;
